import React, { useState, useMemo } from 'react';

import {
  Table,
  TableBody,
  TableRow,
  TableHead,
  TableHeadCell,
  Flex,
  Heading2,
  NoResults,
  Pagination,
  TableCell,
  Button,
  TextInput,
  OrderableTableHeadCell
} from '@ubisend/pulse-components';

import { useMetric } from '../../../hooks/index';
import Scope from '../../Scope';

const orderableTypes = new Set([
  'top-faqs-triggered',
  'average-sentiment-workflow',
  'top-conversations-triggered',
  'sentiment-by-live-chat-agent',
  'negative-sentiment-subscribers',
  'top-resources-triggered-by-generative-ai'
]);

const TableMetric = () => {
  const [search, setSearch] = useState('');
  const { metric, setPage, isLoading, setParams, order } = useMetric();

  const isSearchable = metric.data?.is_searchable;
  const rows = metric.data?.data?.rows?.data || [];
  const headers = metric.data?.data?.headers || [];

  const TableHeadComponent = useMemo(() => {
    return orderableTypes.has(metric.key) ? OrderableTableHeadCell : TableHeadCell;
  }, [metric.key]);

  const handleSearch = () => setParams({ search });
  const handlePageChange = page => setPage(page);

  return (
    <Flex col tall>
      <Flex pad="true" between>
        <Heading2>{metric.data?.label}</Heading2>
        {isSearchable && (
          <Flex xSpaceSm>
            <TextInput
              placeholder="Search..."
              value={search}
              onChange={e => setSearch(e.target.value)}
            />
            <Button variant="secondary" icon="search" onClick={handleSearch}>
              Search
            </Button>
          </Flex>
        )}
      </Flex>

      <Flex fat="true" grow top>
        {rows.length === 0 ? (
          <NoResults />
        ) : (
          <Table loading={isLoading} loadingItems={9}>
            <TableHead>
              <TableRow>
                {headers.map((header, index) => (
                  <TableHeadComponent
                    key={index}
                    row={{ label: header, sort: header }}
                    {...order.props}
                  />
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row, rowIndex) => (
                <TableRow key={rowIndex}>
                  {row.map((column, colIndex) => (
                    <TableCell key={colIndex}>
                      <Scope {...column} />
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </Flex>

      {rows.length > 0 && (
        <Pagination
          pagination={metric.data.data.rows}
          handlePageChange={handlePageChange}
        />
      )}
    </Flex>
  );
};

export default TableMetric;
